<button
  libAndromedaTooltip="{{ tooltipValue }}"
  class="ripple andromeda-button"
  [disabled]="disabled"
  [ngClass]="getClasses()"
  [style.background-color]="
    palette === andromedaPalettes.Primary ? '#0280A3' : 'transparent'
  "
  [style.color]="
    palette === andromedaPalettes.Primary
      ? '#fff'
      : palette === andromedaPalettes.Basic
      ? '#333333'
      : '#333333'
  "
  [style.border]="
    type === andromedaButtonTypes.Flat
      ? palette === andromedaPalettes.Primary
        ? '1px solid #0280A3'
        : '1px solid #333333'
      : 'none'
  "
>
  <ng-content></ng-content>
</button>
